import React, { useMemo } from 'react';
import alertIcon from './alert.gif';
import styled from 'styled-components';
import shopSelectors from 'services/shop/selectors';
import { formatCurrency } from 'utils/formatCurrency';

const NoticeDeposit = () => {
  const settingDeposit = shopSelectors.data.settingDepositBooking();
  const depositLabel = useMemo(() => {
    if (!settingDeposit) return '';
    if (settingDeposit?.depositType === 'PERCENT') {
      return `${settingDeposit.depositValue}%`;
    }
    return formatCurrency(settingDeposit?.depositValue);
  }, [settingDeposit]);

  if (!settingDeposit?.active) return null;

  return (
    <Container>
      <div className="icon-box">
        <img src={alertIcon} alt="alertIcon" />
      </div>
      <div className="notice-box">
        <span>A <b>{depositLabel}</b> deposit is required in advance to secure your appointment.</span>
      </div>
    </Container>
  );
};

export default NoticeDeposit;

const Container = styled.div`
display: flex;
align-items: center;
padding-left: 32px;
margin-bottom: 8px;
.icon-box {
  position: absolute;
  border-radius: 100%;
  overflow: hidden;
  left: 10px;
  height: 75px;
  width: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: auto;
    height: 75px;
    zoom: 1.25;
  }
}
.notice-box {
  display: flex;
  padding: 8px 16px 8px 48px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  border-radius: 16px;
  background: #FF7D00;
  span {
    color: #FFF;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    b {
      color: #FBE696;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
}
`;
